/**
 * Common functionality for the Room components
 */
import InviteMixin from "@/components/DigitalEvent/RoomList/Room/mixins/Invite/InviteMixin";
import { TABLE_TYPES } from "@/helpers/constants";

export default {
  mixins: [InviteMixin],
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    /**
     * Table types
     * @return {Object}
     */
    tableTypes() {
      return TABLE_TYPES;
    },

    /**
     * Active Room
     * @return {Object}
     */
    room() {
      return this.$store.getters["room/activeRoom"];
    },

    /**
     * Check that user has access for networking functionality
     * @return {boolean}
     */
    isNetworkingAllowed() {
      return this.$store.getters["tables/userTable"]
        ? this.$store.getters["tables/userTable"].TABLE_TYPE !== TABLE_TYPES.PUBLIC_GALLERY
        : false;
    },

    /**
     * User table
     * @return {*}
     */
    currentUserTable() {
      return this.$store.getters["tables/userTable"];
    },

    /**
     * Media access error
     * @return {String|null}
     */
    mediaAccessError() {
      return this.$store.state.videoChat.mediaAccessError;
    }
  },
  methods: {
    /**
     * Get user info by User.uuid (from room state)
     * @param userUUID {String}
     * @return {Object}
     */
    getUserByUUID(userUUID) {
      return this.$store.getters["users/getUser"](userUUID);
    },

    /**
     * Small helper to get user's full name from anywhere
     * @param user {Object}
     */
    getUserFullName(user) {
      return this.$store.getters["users/getUserFullName"](user);
    },

    /**
     * Scroll page to my table section
     */
    scrollToMyTable() {
      let userTableElement = document.getElementById("people-chat-container");
      userTableElement.scrollIntoView({ behavior: "smooth" });
    },

    /**
     * Check user uuid
     * @param userUUID {String} User.uuid
     * @return {boolean}
     */
    isMe(userUUID) {
      return this.user.user_uuid === userUUID;
    },

    /**
     * Activate tab by name
     * @param tabNames {Array}
     */
    openTabs(tabNames) {
      tabNames.forEach((tab, index) => {
        setTimeout(() => {
          this.$root.$emit("activateTab", tab);
        }, 300 * index);
      });
    }
  }
};
